<template>
 <section>
    <div class="container" :class="{ 'active' : togleAktif    }">
      <div class="user signinBx">
        <div class="imgBx">

        <img src="/src/assets/monoryumLogoTam.png" alt="Monoryum E-Fatura" />
        </div>
        <div class="formBx">
          <form action="" autocomplete="off" >
          
            <input type="email" v-model="userName" @blur="$v.userName.$touch()" :class="{ 'invalidData': $v.userName.$error }" placeholder="Kullanıcı Adı" />
             
            <input type="password" v-model="password" @blur="$v.password.$touch()" :class="{ 'invalidData':$v.password.$error }" placeholder="Şifre" />
            <button type="submit" :disabled="$v.$invalid" @click.prevent="loginKontrol" class="btn btn-block w-100 ">Monoryuma Giriş</button>
            
            <p class="signup">
              Yeni Kayıt Oluşturmak istiyorum...
              <a href="#" @click.prevent="togleAktif = !togleAktif">YENİ KAYIT</a>
            </p>
          </form>
        </div>
      </div>
      <div class="user signupBx">
        <div class="formBx">
          <form action="" onsubmit="return false;">
            <h2>Create an account</h2>
            <input type="text" name="" placeholder="Username" />
            <input type="email" name="" placeholder="Email Address" />
            <input type="password" name="" placeholder="Create Password" />
            <input type="password" name="" placeholder="Confirm Password" />
            <input type="submit" name="" value="Sign Up" />
            <p class="signup">
              Already have an account ?
              <a href="#" @click.prevent="togleAktif = !togleAktif">Sign in.</a>
            </p>
          </form>
        </div>
        <div class="imgBx "><img src="/src/assets/monoryumLogoTam.png" alt="Monoryum E-Fatura" /></div>
      </div>
    </div>
  </section>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
import axios from "axios"
import https from 'https';
export default {
	data(){
		return{
			togleAktif:false,
      userName:null,
      password:null
		}
	},
  
  methods:{

    loginKontrol:function(){


          axios.post("https://ws.monoryum.com/token",{ data :{"username":this.userName,"password":this.password,"grant_type":"password"}})
          .then((res)=>{
            console.log(res);
          })
  
     }
  },
  validations:{
    userName:{
      required,
      email
    },
    password:{
      required
    }
  },
  created(){
       this.userName=null
       this.password=null
  }
  
}
 
 
</script>

<style scoped>


.invalidData{

  border:1px solid red !important;
   
}

section {
  position: relative;
  min-height: 100vh;
  background-color: #670ca3;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
 
}

section .container {
  position: relative;
  width: 800px;
  height: 500px;
  background: #fff;
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.1);
  overflow: hidden;
   border-radius: 20px;;
}

section .container .user {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
}

section .container .user .imgBx {
  position: relative;
  width: 50%;
  height: 100%;
  background: white;
  transition: 0.5s;
  display:flex;
  align-items:center;
  justify-content:center;
  text-align:center;
}

section .container .user .imgBx img {
  
   
  width: 50%;
  height: auto !important;
   
   
}

section .container .user .formBx {
  position: relative;
  width: 50%;
  height: 100%;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
  transition: 0.5s;
}

section .container .user .formBx form h2 {
  font-size: 18px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 2px;
  text-align: center;
  width: 100%;
  margin-bottom: 10px;
  color: #555;
}

section .container .user .formBx form input {
  position: relative;
  width: 100%;
  padding: 10px;
  background: #f5f5f5;
  color: #333;
  border: none;
  outline: none;
  box-shadow: none;
  margin: 8px 0;
  font-size: 14px;
  letter-spacing: 1px;
  font-weight: 300;
}


section .container .user .formBx form button[type='submit'] {
  
  background: #670ca3;
  color: #fff;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 1px;
  transition: 0.5s;
}
section .container .user .formBx form button[type='submit'] :disabled {
  
  background: lightgray;
  color: #fff;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 1px;
  transition: 0.5s;
}
section .container .user .formBx form .signup {
  position: relative;
  margin-top: 20px;
  font-size: 12px;
  letter-spacing: 1px;
  color: #555;
  text-transform: uppercase;
  font-weight: 300;
}

section .container .user .formBx form .signup a {
  font-weight: 600;
  text-decoration: none;
  color: #677eff;
}

section .container .signupBx {
  pointer-events: none;
}

section .container.active .signupBx {
  pointer-events: initial;
}

section .container .signupBx .formBx {
  left: 100%;
}

section .container.active .signupBx .formBx {
  left: 0;
}

section .container .signupBx .imgBx {
  left: -100%;
}

section .container.active .signupBx .imgBx {
  left: 0%;
}

section .container .signinBx .formBx {
  left: 0%;
}

section .container.active .signinBx .formBx {
  left: 100%;
}

section .container .signinBx .imgBx {
  left: 0%;
}

section .container.active .signinBx .imgBx {
  left: -100%;
}

@media (max-width: 991px) {
  section .container {
    max-width: 400px;
  }

  section .container .imgBx {
    display: none;
  }

  section .container .user .formBx {
    width: 100%;
  }
}

</style>



// WEBPACK FOOTER //
// components/Login/login.vue